export class IngestContainerModel {
  constructor(public sasToken: string, public containerName: string) { }
}



// WEBPACK FOOTER //
// ./src/app/models/ingest-container.model.ts